import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Access from "./Access"; // Assuming Access is in the same directory
import { Authorization } from "../../../Context/Authorization";

const AddUser = ({ onClose, onAddUser }) => {
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [access, setAccess] = useState({
    stateId: "",
    circleId: "",
    divisionId: "",
    rangeId: "",
    vfcId: "",
  });
  const [showAccessModal, setShowAccessModal] = useState(false);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const Confiq = Authorization();
        const response = await axios.get(`${Api}/api/users/roles`, Confiq);
        setRoles(response.data);
      } catch (err) {
        console.error("Error fetching roles", err);
      }
    };

    fetchRoles();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      username,
      name,
      designation,
      password,
      email,
      role,
      access,
    };

    try {
      const Confiq = Authorization();
      const response = await fetch(`${Api}/api/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...Confiq.headers,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("success", result);
        toast.success("User added successfully!");
        onAddUser();
        setAccess();
        onClose();
      } else {
        console.error("Error adding user:", response.statusText);
        toast.error("Failed to add user");
      }
    } catch (error) {
      console.error(
        "Error adding user:",
        error.response?.data || error.message
      );
      toast.error("Failed to add user");
    }
  };

  const handleOpenAccessModal = () => {
    setShowAccessModal(true);
  };

  const handleCloseAccessModal = () => {
    setShowAccessModal(false);
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Add User</Modal.Title>
        <Button
          variant="outline-danger"
          onClick={onClose}
          style={{ marginLeft: "auto" }}
        >
          X
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Username</Form.Label>
            <div className="input-container">
              <Form.Control
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Name</Form.Label>
            <div className="input-container">
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Designation</Form.Label>
            <div className="input-container">
              <Form.Control
                type="text"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                required
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Password</Form.Label>
            <div className="input-container">
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Email</Form.Label>
            <div className="input-container">
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Role</Form.Label>
            <div className="input-container">
              <Form.Control
                as="select"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
              >
                <option value="">Select role</option>
                {roles.map((role) => (
                  <option key={role._id} value={role._id}>
                    {role.roleName}
                  </option>
                ))}
              </Form.Control>
            </div>
          </Form.Group>
          <Button variant="primary" onClick={handleOpenAccessModal}>
            Set Access
          </Button>
          <Button type="submit" className="ml-2">
            Submit
          </Button>
        </Form>
      </Modal.Body>

      {/* Access Modal */}
      {showAccessModal && (
        <Access
          show={showAccessModal}
          onHide={handleCloseAccessModal}
          setAccess={setAccess}
        />
      )}
    </Modal>
  );
};

export default AddUser;
